module.exports = __webpack_public_path__ + "assets/img/empty-history.31b8c433.png";